/**
 * "Reducir movimiento" del sistema. Hace falta en lo que corre con Web Animations, como Ionic, porque la regla
 * de `base.css` sólo alcanza a las animaciones y transiciones de CSS.
 */
export function prefersReducedMotion(): boolean {
  return typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches;
}
